// extracted by mini-css-extract-plugin
export default {"text":"About_text__Gw0ud","bg_animation":"About_bg_animation__x2axe","flex_container":"About_flex_container__hZ6Wp"};